import * as Dtos from '../../dtos/Tmd.dtos';

export const
    setEditModalViewState: ITrialGroupItemsPageSetEditModalViewStateActionCreator = (open, collectionInstanceId, name, description) => {
        return {
            type: ACTION_TRIALGROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
            open,
            collectionInstanceId,
            name,
            description
        }
    },
    setCreateVersionModalViewState: ITrialGroupItemsPageSetCreateVersionModalViewStateActionCreator = (open, trialGroupItem) => {
        return {
            type: ACTION_TRIALGROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE,
            open,
            trialGroupItem
        }
    }

export const
    ACTION_TRIALGROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE = "ACTION_TRIALGROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    ACTION_TRIALGROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE = "ACTION_TRIALGROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE"

/* Actions */

export interface ITrialGroupItemsPageSetEditModalViewStateAction {
    type: "ACTION_TRIALGROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    open: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
}

export interface ITrialGroupItemsPageSetCreateVersionModalViewStateAction {
    type: "ACTION_TRIALGROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE",
    open: boolean;
    trialGroupItem: Dtos.TrialGroupItem
}

/* Action Creators */

export interface ITrialGroupItemsPageSetEditModalViewStateActionCreator {
    (
        open: boolean,
        collectionIntanceId: number,
        name: string,
        description: string
    ): ITrialGroupItemsPageSetEditModalViewStateAction;
}

export interface ITrialGroupItemsPageSetCreateVersionModalViewStateActionCreator {
    (
        open: boolean,
        trialGroupItem: Dtos.TrialGroupItem
    ): ITrialGroupItemsPageSetCreateVersionModalViewStateAction;
}


/* Final Export of actions */
export type TrialGroupItemsPageAction =
    ITrialGroupItemsPageSetEditModalViewStateAction |
    ITrialGroupItemsPageSetCreateVersionModalViewStateAction;
